import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import "../Assets/css/layout.css";
import logoutprofile from "../Assets/Img/logoutprofile.png";
import axiosMain from "../http/axiosMain";
import Notifications from "../Main/Notification";
import { GlobalContext } from "../../utils/GlobalContext";
import NotificationsImg from "../Assets/Img/Notification iconn.svg";
import { Box, Typography } from "@mui/material";
import { getInitials } from "../../utils/functions";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Settings, UserRound, Wallet } from "lucide-react";

function Navbar() {
  const today = new Date();
  const { userData, setUserData } = useContext(GlobalContext);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const [ProfilePicture, setProfilePicture] = useState();
  const [creatorCount, setCreatorCount] = useState(0);

  const [userType, setUserType] = useState("");

  useEffect(() => {
    const type = localStorage.getItem("userType");
    setUserType(type);
  }, []);

  useEffect(() => {
    const fetchBrandProfile = async () => {
      try {
        const response = await axiosMain.get("/api/v1/get-brand-profile");
        if (response.data?.user?.user_photo) {
          setProfilePicture(response.data.user.user_photo);
        }
      } catch (error) {
        console.error("Error fetching brand profile:", error);
      }
    };
    fetchBrandProfile();
  }, []);

  useEffect(() => {
    const fetchInfluencers = async () => {
      try {
        const response = await axiosMain.get("/api/influencer/influencers");
        const influencers = response.data.totalCount ?? 0;
        setCreatorCount(influencers);
      } catch (error) {
        console.error("Error fetching influencers:", error);
      }
    };
    fetchInfluencers();
  }, []);

  const [unreadCount, setUnreadCount] = useState(0);
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axiosMain.get(
          "/api/notifications/notifications"
        );
        const allNotifications = response.data.data;
        const unreadNotifications = allNotifications.filter(
          (notif) => notif.status === "unread"
        );
        setUnreadCount(unreadNotifications.length);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };
    fetchNotifications();
  }, []);

  const handleNotificationClick = () => {
    localStorage.setItem("previousPage", location.pathname);
  };

  const options = { weekday: "long", day: "numeric", month: "short" };
  const formattedDate = today.toLocaleDateString("en-US", options);

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showNotification, setShowNotification] = useState(true);

  const role = localStorage.getItem("userType");

  const pageTitles = {
    "/": "Home",
    "/brand-home": `Creators (${creatorCount})`,
    "/payment": "Payment",
    "/message": "Message",
    "/notifications": "Notifications",
    "/myprofile": "My Profile",
    "/settings": "Settings",
    "/messages/chat": "Chat",
    "/campaign": role === "influencer" ? "Dashboard" : "Campaign",
    "/insights": "Insights",
    "/campaign/campaign-details/:id": "Campaign Detail",
    "/influencer-home": "All Campaign",
    "/insightcard": role === "brand" ? "Track Your Campaign" : "Insights",
    "/campaign-create": "Campaign",
    "/influencerstats": "Statistics",
    "/dashboardqueries": "Queries",
    "/dashboard-home": "Dashboard",
    "/dashboard-influencer": "Dashboard",
  };

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const mainPage = `/${pathSegments[0] || ""}`;
  const childPage =
    pathSegments.length > 1 ? `/${pathSegments.join("/")}` : null;

  const mainTitle = pageTitles[mainPage] || "Navbar";
  const childTitle =
    childPage && pageTitles[childPage] ? ` / ${pageTitles[childPage]}` : "";

  const confirmLogout = async () => {
    try {
      const response = await axiosMain.post(
        "/api/auth/logout",
        {},
        { withCredentials: true }
      );
      if (response.status === 200) {
        const rememberedEmail = localStorage.getItem("rememberedEmail");
        localStorage.clear();
        window.location.reload();
        if (rememberedEmail) {
          localStorage.setItem("rememberedEmail", rememberedEmail);
        }
      }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setShowLogoutModal(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const storedNotification = localStorage.getItem("showNotification");

    if (storedNotification === null) {
      // Default to true if not set
      localStorage.setItem("showNotification", "true");
      setShowNotification(true);
    } else {
      setShowNotification(storedNotification === "true");
    }

    const handleStorageChange = () => {
      setShowNotification(localStorage.getItem("showNotification") === "true");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <nav className="navbar navbar-expand">
      <div className="container-fluid">
        <div className="collapse navbar-collapse justify-content-end">
          <form className="d-flex align-items-center">
            {/* <h6 className="nav-date">{formattedDate}</h6> */}

            <div
              onClick={() => setShowNotifications(true)}
              style={{ cursor: "pointer" }}
            >
              {showNotification ? (
                <div className="NavbarNotificationImage">
                  <img
                    src={NotificationsImg}
                    className="img-fluid"
                    alt="Notifications"
                  />
                  <span className="notification-badge">
                    <p className="notification-unreadcount">{unreadCount}</p>
                  </span>
                </div>
              ) : (
                <div className="NavbarNotificationImage">
                  <img
                    src={NotificationsImg}
                    className="img-fluid"
                    alt="Notifications"
                  />
                </div>
              )}
            </div>

            <Modal
              show={showNotifications}
              onHide={() => setShowNotifications(false)}
              centered
              size="lg"
            >
              <Modal.Body>
                <Notifications onClose={() => setShowNotifications(false)} />
              </Modal.Body>
            </Modal>

            <div className="ProfileIcon" ref={dropdownRef}>
              <div
                onClick={() => setShowDropdown(!showDropdown)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50px",
                  gap: "6px",
                  backgroundColor: "rgb(255 255 255)",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.19)",
                }}
              >
                <Box
                  sx={{
                    width: "40px",
                    height: "40px",
                    marginLeft: "2px",
                    borderRadius: "50%",
                    border: "2px solid white",
                    background: " rgba(255, 205, 102, 1)",
                    fontFamily: "Poppins, sans-serif",
                  }}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Typography fontSize={"1rem"} color="#fff">
                    {getInitials(userData?.first_name, userData?.last_name)}
                  </Typography>
                </Box>
                <ArrowDropDownIcon style={{ color: "#545455" }} />
              </div>

              {showDropdown && (
                <div className="user-dropdown-menu">
                  <ul>
                    <li
                      className="profile-nav nav-drop"
                      onClick={() => {
                        setShowDropdown(false);
                        navigate("/myprofile");
                        localStorage.removeItem("Brand_id");
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <UserRound color="rgba(101, 101, 101, 1)" size={16} />
                        <Typography variant="body2" color="text.primary">
                          My Profile
                        </Typography>
                      </Box>
                    </li>
                    {userType === "influencer" && (
                      <li
                        className="profile-nav nav-drop"
                        onClick={() => {
                          setShowDropdown(false);
                          navigate("/my-wallet");
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1}>
                          <Wallet color="rgba(101, 101, 101, 1)" size={16} />
                          <Typography variant="body2" color="text.primary">
                            My Wallet
                          </Typography>
                        </Box>
                      </li>
                    )}

                    <li
                      className="setting-nav nav-drop"
                      onClick={() => {
                        setShowDropdown(false);
                        navigate("/settings");
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <Settings color="rgba(101, 101, 101, 1)" size={16} />
                        <Typography variant="body2" color="text.primary">
                          Privacy Settings
                        </Typography>
                      </Box>
                    </li>

                    <li
                      className="logout-nav nav-drop"
                      onClick={() => {
                        setShowDropdown(false);
                        setShowLogoutModal(true);
                      }}
                    >
                      <img
                        src={logoutprofile}
                        alt="Logout"
                        className="nav-menu-icon"
                      />
                      Sign Out
                    </li>
                  </ul>
                </div>
              )}

              <Modal
                show={showLogoutModal}
                onHide={() => setShowLogoutModal(false)}
                centered
              >
                <Modal.Body className="text-center">
                  {/* <h5>Leaving so soon?</h5> */}
                  <h5>Are you sure you want to logout?</h5>
                  <div className="mt-4">
                    <Button
                      variant="danger"
                      onClick={confirmLogout}
                      className="me-2"
                      style={{ backgroundColor: "rgba(107, 142, 118, 1)" }}
                    >
                      Logout
                    </Button>
                    <Button
                      variant="btn-secondary"
                      onClick={() => setShowLogoutModal(false)}
                      style={{ border: "1px solid gray" }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
